export const HERO_CONTENT = {
  title: 'When The Mind Clears, Life\nTransforms In Its Reflection.',
  subtitle: '— Nirva Creed',
  text: 'Within every person lies the spark of infinite potential.',
  textSecondary: `At Nirva, we make hypnotherapy accessible worldwide—offering safe, confidential, and transformative online sessions that help people\novercome challenges and awaken to their true selves.`,
};

export const PILLS = [
  'Online sessions with IAIH-certified hypnotherapists',
  'Confidential, HIPAA-compliant care from home',
  'Personalized support for stress, habits, emotions, and relationships',
  'Rooted in integrity, professionalism, and compassion',
];
